// extracted by mini-css-extract-plugin
export default {"card":"messenger_card__glz-g","card_img":"messenger_card_img__Oh+n8","card_text":"messenger_card_text__aEwoh"};